import { render, staticRenderFns } from "./CMUserResetPassword.vue?vue&type=template&id=7b49e9f0&scoped=true&"
import script from "./CMUserResetPassword.vue?vue&type=script&lang=js&"
export * from "./CMUserResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./CMUserResetPassword.vue?vue&type=style&index=0&id=7b49e9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b49e9f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b49e9f0')) {
      api.createRecord('7b49e9f0', component.options)
    } else {
      api.reload('7b49e9f0', component.options)
    }
    module.hot.accept("./CMUserResetPassword.vue?vue&type=template&id=7b49e9f0&scoped=true&", function () {
      api.rerender('7b49e9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/user/CMUserResetPassword.vue"
export default component.exports